import { useIntl } from 'react-intl';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import NoRowsImage from '@/pages/company/DashboardRoute/pages/VendorExpensesRoute/components/NoRowsOverlayComponent/image.svg';

const NoRowsOverlayComponent = () => {
  const { formatMessage } = useIntl();

  return (
    <Box
      height="100%"
      width="100%"
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minWidth={500}
      maxWidth={700}
      p={1}
    >
      <Box maxWidth={300} minHeight={0} maxHeight={240}>
        <img src={NoRowsImage} alt="no-rows-image" height="100%" />
      </Box>

      <Typography
        sx={{
          typography: { xl: 'h5', xs: 'h6' },
          fontWeight: { xl: 400, xs: 400 },
        }}
        mt={2}
        mb={1}
      >
        {formatMessage({
          id: 'empty.grid.noResults.title',
          defaultMessage: 'No results found',
        })}
      </Typography>
      <Typography variant="body1" color="text.secondary" mb={2} sx={{ typography: { xl: 'body1', xs: 'body2' } }}>
        {formatMessage({
          id: 'empty.grid.noResults.description',
          defaultMessage: 'No results found for the selected filters.',
        })}
      </Typography>
    </Box>
  );
};

export default NoRowsOverlayComponent;
